import { AlertTriangle, BarChart2 } from 'lucide-react';
import React from 'react';

import { Notification } from '../../../types/notification';
import { Button } from '../../ui/button';

interface ItemProps {
  notification: Notification;
  onAction: (n: Notification, handler: string) => void;
}

export const SystemAlertItem: React.FC<ItemProps> = ({
  notification,
  onAction,
}) => {
  return (
    <div
      className={`relative flex gap-4 rounded-lg border p-4 transition-colors ${notification.read ? 'bg-background' : 'bg-orange-50/50 border-orange-200'}`}
    >
      <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-100 text-orange-600'>
        <AlertTriangle className='h-5 w-5' />
      </div>
      <div className='flex-1 space-y-1'>
        <div className='flex items-center justify-between'>
          <p className='text-sm font-medium leading-none text-orange-900'>
            {notification.title}
          </p>
          <span className='text-xs text-muted-foreground'>
            {new Date(notification.timestamp).toLocaleTimeString()}
          </span>
        </div>

        <p className='text-sm text-muted-foreground'>
          {notification.description}
        </p>

        <div className='flex gap-2 pt-2'>
          <Button
            size='sm'
            variant='outline'
            className='h-7'
            onClick={() => onAction(notification, 'VIEW_METRICS')}
          >
            <BarChart2 className='mr-1 h-3 w-3' /> View Metrics
          </Button>
        </div>
      </div>
    </div>
  );
};
